<template>
  <div v-if="data">
    <div class="flex flex-nowrap px-3rem pb-1.7rem space-x-10">
      <div class="space-y-4">
        <p>{{ $t("订单编号") }}：{{ data.ordernum }}</p>
        <p class="text-green-500 text-lg">
          <!-- <span v-if="data.xdelivered && data.status_text == '待发货'">{{
            $t("待收货")
          }}</span>
          <span v-else>{{$t(data.status_text) }}</span> -->
          <span>{{ orderStatus[data.status] }}</span>
        </p>
        <p v-if="!(data.status === -1)">
          <el-button type="warning" round size="small" v-if="data.status === 0" @click="showPayType = true" class="take">
            {{ $t("去付款") }}
          </el-button>
          <el-button type="warning" round size="small" v-else-if="data.status === 10" @click="remind(data.id)"
            class="take">
            {{ $t("提醒发货") }}
          </el-button>
          <el-button v-else-if="data.status === 100" @click="finishOrder(data.id)" type="warning" round size="small"
            class="take">
            {{ $t("确认收货") }}
          </el-button>
          <!-- <el-button
            v-else-if="data.status === 10"
            type="warning"
            round
            disabled
            class="take"
          >
            {{ $t("确认收货") }}
          </el-button> -->


          <el-button type="primary" round v-else :disabled="btnComDisabled" size="small" class="comment">
            <span v-if="!data.commenttime" @click="comment(data.id)">{{
              $t("去评价")
            }}</span>
            <span v-else>{{ $t("已评价") }}</span>
          </el-button>
        </p>
      </div>
      <el-steps :active="active" align-center class="w-38rem step mt-6">
        <el-step :title="$t('提交订单')"></el-step>
        <el-step :title="$t('付款')"></el-step>
        <el-step :title="$t('收货')"></el-step>
        <el-step :title="$t('评价')"></el-step>
      </el-steps>
    </div>
    <p class="h-4 bg-mainGray -mx-8 mb-4"></p>

    <div class="grid grid-cols-[1fr,1rem,1fr] gap-8">
      <OrderInfo :item="data"></OrderInfo>
      <p class="w-4 h-4 bg-mainGray py-42 -mt-8 -mb-8 m-auto"></p>
      <div class="flex flex-col items-start">
        <div class="font-bold">{{ $t('收货信息') }}</div>
        <div class="pt-2 space-y-2 flex flex-col items-start">
          <span>{{ $t('收货人') }}：{{ data.receiver }}</span>
          <span>{{ $t('电话') }}：{{ data.phone }}</span>

          <span>{{ $t('地址') }}：{{ data.address }}</span>

        </div>
      </div>
    </div>
    <Comment :data="data.items[0].comment" v-if="data.commenttime"></Comment>
    <p class="h-4 bg-mainGray mt-8 -mx-8"></p>
    <ProductInfo class="mt-8" :data="data"></ProductInfo>
    <div class="mt-8 foot">
      <div></div>
      <div class="text-gray-500 flex flex-col items-start mr-8">
        <p>
          <span>{{ $t("商品总额") }}：</span>
          <span>{{ $p(data.totalprice) }}</span>
        </p>
        <p>
          <span>{{ $t("运费") }}：</span>
          <span>{{ $p(data.transfee) }}</span>
        </p>
        <p>
          <span>{{ $t("促销立减") }}：</span>
          <span>{{ $p(0) }}</span>
        </p>
        <p>
          <span>{{ $t("包装费") }}：</span>
          <span>{{ $p(data.packagefee) }}</span>
        </p>
        <p>
          <span class="text-blue-400">{{ $t("预估报关报检费") }}：</span>
          <span>{{ $p(data.otherfee) }}</span>
        </p>
        <p class="mt-4">
          <span class="text-left">{{ $t("实际付款") }}：</span>
          <span class="text-red-500 text-3xl ml-0">{{
            $p(data.finalprice)
          }}</span>
        </p>
      </div>
    </div>
    <ReadyPay ref="readypay"></ReadyPay>
    <payInfo :show="showPayInfo" @close="showPayInfo = false" :sid="data.supplier_id"></payInfo>
    <el-dialog :title="$t('选择付款方式')" :visible.sync="showPayType">
      <div class="space-x-20 flex-center">
        <div v-for="type in types" @click="payOrder(type.key)" :key="type.key">
          <img :src="$smallImage(type.img)" class="w-16 h-16">
          <el-link>{{ type.text }}</el-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OrderInfo from "/src/components/mine/order/orderInfo.vue";
// import FlightInfo from "/src/components/mine/order/flightInfo.vue";
import ProductInfo from "/src/components/mine/order/productInfo.vue";
import ReadyPay from "/src/components/base/ir-readypay.vue";
import Comment from "/src/components/mine/order/comment.vue";
import payInfo from "../../../components/base/payInfo.vue";
import { onMounted, ref, computed, reactive } from "@vue/composition-api";
export default {
  // components: { OrderInfo, FlightInfo, ProductInfo, ReadyPay, Comment },
  components: { OrderInfo, ProductInfo, ReadyPay, Comment, payInfo },
  setup(props, ctx) {
    const data = ref();
    const active = ref();
    const btnComDisabled = computed(() =>
      data?.value?.commenttime ? true : false
    );
    const getOrderDetail = async () => {
      ctx.root.$doing()
      data.value = (
        await ctx.root.$callapi("user/getOrderDetail", ctx.root.$route.params)
      ).data;
      ctx.root.$done()

      switch (data.value?.status) {
        case -1:
          active.value = 0;
          break;
        case 0:
          active.value = 1;
          break;
        case 10:
        case 100:
          active.value = 3;
          break;
        default:
          active.value = 4;
          break;
      }
      // if (!data.value?.finalpaid && ctx.root.$route.query.pay) {
      //   ctx.root.$nextTick(() => {
      //     payOrder(data.value);
      //   });
      // }
    };
    onMounted(async () => {
      getOrderDetail();
    });
    //去评论
    const comment = (id) => {
      ctx.root.$router.push({
        name: "evaluation",
        params: { id },
      });
    };
    //确认收货
    const finishOrder = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确定已收到货?"));
      if (res) {
        ctx.root.$doing();
        await ctx.root.$callapi("user/doForOrderAction", {
          action: "finish",
          ids: [id],
        });
        getOrderDetail();
        ctx.root.$done();
      }
    };

    // 支付订单
    const readypay = ref(null);
    const showPayInfo = ref(false)
    const showPayType = ref(false)

    const payOrder = async (key) => {
      if (key == 'online') {
        ctx.root.$refs.readypay = readypay.value;
      let r = await ctx.root.$startPay({
        payfor: "newpay", // 收银台订单
        money: data.value.finalprice, // 金额
        title: ctx.root.$t("支付订单{num}").replace("{num}", data.value.ordernum),
        data: {
          oid: data.value.id,
          now_platform: "webpc",
          origin_url: "/mine/order/detail/" + data.value.id, // 从哪个页面发起付款的
        },
      });
      if (r) {
        await ctx.root.$toast(ctx.root.$t("付款成功!"), "success");
        getOrderDetail();
      }
      } else if (key == 'offline') {
        showPayInfo.value = true
      }

     
     
    };

// 提醒发货
const remind = async (id) => {
  const res = await ctx.root.$query(ctx.root.$t("点击确认将向商家发送发货提醒?"));
  if (res) {
    let res = await ctx.root.$callapi('remindSend', {
      oid: id
    })
    if (res.code == 0) {
      ctx.root.$toast(ctx.root.$t('提醒发货成功'), "success");
    }
  }
}
const orderStatus = reactive({
  '-1': ctx.root.$t('已取消'),
  '0': ctx.root.$t('待付款'),
  '10': ctx.root.$t('待发货'),
  '100': ctx.root.$t('待收货'),
  '1000': ctx.root.$t('已完成')
})
const types = [
  {
    key: 'online',
    img: 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230424/Ft1w8EX_8QbnQ_cT5xhpXBm69jWS.png',
    text: ctx.root.$t('在线支付')
  },
  {
    key: 'offline',
    img: 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230424/FhIbNw2RXvuidXhueMyEYmPIjUFT.png',
    text: ctx.root.$t('记账支付')
  }
]


return {
  data,
  active,
  btnComDisabled,
  comment,
  finishOrder,
  payOrder,
  readypay,
  showPayInfo,
  remind,
  orderStatus,
  types,
  showPayType

};
  },
};
</script>
<style scoped lang="scss">.foot {
  display: -ms-grid;
  display: grid;
}
.span_list span {
  display: block;
  line-height: 2.5rem;
}
.span_list .gradient {
  line-height: 2rem;
  margin-top: 0.5rem;
  padding-bottom: 2.5rem;
  border-radius: 1.13rem;
  background: linear-gradient(-97.27deg, #ff4a4a 0%, #ff8a00 100%);
}
.step ::v-deep .el-step__head.is-process {
  border-color: #c0c4cc;
  color: #c0c4cc;
}
.step ::v-deep .el-step__title.is-process {
  color: #c0c4cc;
  font-weight: normal;
}
.take {
  font-size: 0.94rem;
  min-width: 5.6rem;
  background: linear-gradient(-97.27deg, #ff4a4a 0%, #ff8a00 100%);
}
.take:hover {
  background: #ff8a00;
}
.comment {
  font-size: 0.94rem;
  min-width: 5.6rem;
  background: linear-gradient(-97.27deg, #6ed490 0%, #34b66b 100%);
  border: 0;
}
.comment:hover {
  background: #6ed490;
}</style>
